import { APPROVED_PREDICTION_SYMBOLS, type Position, type TradeHistoryItem } from './types'

export function isApprovedPredictionSymbol(symbol?: string | null): boolean {
  if (!symbol) return false
  return (APPROVED_PREDICTION_SYMBOLS as readonly string[]).includes(symbol.toUpperCase())
}

export function filterPredictionPositions(positions: Position[]): Position[] {
  return positions.filter((p) => isApprovedPredictionSymbol(p.symbol))
}

export function filterPredictionTrades(trades: TradeHistoryItem[]): TradeHistoryItem[] {
  return trades.filter((t) => isApprovedPredictionSymbol(t.symbol))
}

export function money(value: string | number | null | undefined, digits = 2): string {
  const n = Number(value ?? 0)
  if (!Number.isFinite(n)) return '—'
  return n.toFixed(digits)
}
